// Lightweight analytics beacon. Generates a session id (24h TTL) and POSTs
// one visit event per page-mount plus one step event per wizard step change.
// Never throws — tracking must never break the customer flow.
import axios from "axios";

const SESSION_KEY = "ts_session_id";
const SESSION_TS_KEY = "ts_session_ts";
const SESSION_TTL_MS = 24 * 60 * 60 * 1000; // 24h
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const uuid = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID) return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
  });
};

export const getSessionId = () => {
  try {
    const existing = localStorage.getItem(SESSION_KEY);
    const ts = parseInt(localStorage.getItem(SESSION_TS_KEY) || "0", 10);
    if (existing && Date.now() - ts < SESSION_TTL_MS) return existing;
    const id = uuid();
    localStorage.setItem(SESSION_KEY, id);
    localStorage.setItem(SESSION_TS_KEY, String(Date.now()));
    return id;
  } catch {
    // Private mode / storage blocked → fall back to in-memory id (re-rolls each load)
    return uuid();
  }
};

export const trackVisit = (page) => {
  try {
    axios.post(
      `${API}/track`,
      { kind: "visit", session_id: getSessionId(), page },
      { withCredentials: true }
    ).catch(() => {});
  } catch {
    /* never throw */
  }
};

export const trackStep = (step, extra = {}) => {
  try {
    axios.post(
      `${API}/track`,
      { kind: "step", session_id: getSessionId(), step, ...extra },
      { withCredentials: true }
    ).catch(() => {});
  } catch {
    /* never throw */
  }
};
